/**
 * @readonly
 * @enum {string}
 */
export const CameraStatus = {
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE',
    STANDBY: 'STANDBY',
    UNKNOWN: 'UNKNOWN'
}
